import { Box, HStack, Image, Stack, Text } from "@chakra-ui/react";
import React from "react";
import BookAppointment from "../../../assets/jewellery/book-appointment.png";
import { Link } from "react-router-dom";

export default function BookAnAppointment() {
  return (
    <Stack py={5}>
      <HStack
        justify="space-between"
        flexDirection={{ base: "column", md: "row" }}
      >
        <Image src={BookAppointment} maxW={{ base: "full", md: "50%" }} />

        <Stack flex={1} align={{ base: "flex-start", md: "center" }} w="full">
          <Box maxW="lg">
            <Text fontSize="3xl" fontWeight="semibold">
              Book an virtual appointment
            </Text>
            <Text fontSize="xl">
              Need help in choosing? Discover lab diamond jewellery for any
              occasion!!
            </Text>
            <Link to="/appointment">
              {/* <Text
              textDecorationLine="underline"
              fontWeight="semibold"
              cursor="pointer"
              as="span"
            >
              IN-PERSON APPOINTMENT
            </Text> */}
            </Link>
          </Box>
        </Stack>
      </HStack>

      <Box fontWeight="100" mt={4}>
        <Text>
          Your peace of mind is our priority. Every order is delivered via
          insured 2-day shipping on us.
        </Text>
        <Text>
          We want you to shop stress-free, so we offer a 30-day complimentary
          return policy on all of our engagement rings. Learn more about our
          full return policy and exclusions at our FAQ.
        </Text>
      </Box>
    </Stack>
  );
}
